// Animated scene visualizers for the car-deck LCD. Each draws one frame: (ctx, f) where
// f = { w, h, t (seconds), pulse (0..1, 1 on the beat), beat (int), frac (0..1 within beat), lv (24 levels), bass, c1, c2, s (persistent state) }.

const wave = (x, t, h) => h * 0.72 + Math.sin(x * 0.035 + t * 2) * 3 + Math.sin(x * 0.09 - t * 3) * 1.5;

const dolphinShape = (ctx, size) => {
  ctx.beginPath();
  ctx.ellipse(0, 0, size, size * 0.32, 0, 0, Math.PI * 2);
  ctx.moveTo(-size * 0.1, -size * 0.25); ctx.lineTo(size * 0.15, -size * 0.65); ctx.lineTo(size * 0.3, -size * 0.2);
  ctx.moveTo(-size * 0.9, 0); ctx.lineTo(-size * 1.35, -size * 0.35); ctx.lineTo(-size * 1.2, 0); ctx.lineTo(-size * 1.35, size * 0.35); ctx.closePath();
  ctx.moveTo(size * 0.9, -size * 0.05); ctx.lineTo(size * 1.25, 0); ctx.lineTo(size * 0.9, size * 0.1);
  ctx.fill();
};

export const DOLPHIN = (ctx, { w, h, t, beat, frac, bass, c1, c2 }) => {
  ctx.strokeStyle = c1; ctx.lineWidth = 2; ctx.beginPath();
  for (let x = 0; x <= w; x += 4) { const y = wave(x, t, h); x ? ctx.lineTo(x, y) : ctx.moveTo(x, y); }
  ctx.stroke();
  ctx.globalAlpha = 0.35;
  for (let x = (t * 40) % 24; x < w; x += 24) ctx.fillRect(x, wave(x, t, h) + 6 + ((x / 24) % 3) * 4, 8, 1.5);
  ctx.globalAlpha = 1;
  [0, 1, 2].forEach((k) => {
    const p = (((beat + k * 0.66) % 2) + frac) / 2; // each dolphin jumps over 2 beats
    const x0 = ((k * 0.33 + t * 0.04) % 1) * (w + 80) - 40;
    const x = x0 + p * w * 0.18;
    const y = h * 0.72 - Math.sin(p * Math.PI) * h * (0.45 + bass * 0.25);
    const ang = Math.atan2(-Math.cos(p * Math.PI) * h * 0.5, w * 0.18);
    ctx.save(); ctx.translate(x, y); ctx.rotate(-ang * 0.9);
    ctx.fillStyle = k === 1 ? c2 : c1;
    dolphinShape(ctx, h * 0.11);
    ctx.restore();
    if (p > 0.9 || p < 0.1) { ctx.fillStyle = c2; for (let d = -2; d <= 2; d++) ctx.fillRect(x + d * 4, h * 0.68 - Math.abs(d) * 2 - (1 - Math.abs(p - 0.5) * 2) * 4, 2, 2); }
  });
};

const palm = (ctx, x, base, hgt, c) => {
  ctx.strokeStyle = c; ctx.lineWidth = 3; ctx.beginPath();
  ctx.moveTo(x, base); ctx.quadraticCurveTo(x + hgt * 0.15, base - hgt * 0.5, x + hgt * 0.05, base - hgt); ctx.stroke();
  ctx.lineWidth = 2;
  [-2.6, -2, -1.2, -0.5, 0.2].forEach((a) => {
    ctx.beginPath(); ctx.moveTo(x + hgt * 0.05, base - hgt);
    ctx.quadraticCurveTo(x + hgt * 0.05 + Math.cos(a) * hgt * 0.35, base - hgt + Math.sin(a) * hgt * 0.25, x + hgt * 0.05 + Math.cos(a) * hgt * 0.5, base - hgt + hgt * 0.15);
    ctx.stroke();
  });
};

const lowrider = (ctx, x, y, L, tilt, c1, c2, t) => {
  ctx.save(); ctx.translate(x, y); ctx.rotate(tilt);
  const H = L * 0.16;
  ctx.fillStyle = c1;
  ctx.beginPath();
  ctx.moveTo(-L / 2, 0); ctx.lineTo(-L / 2, -H * 0.9); ctx.lineTo(-L * 0.28, -H); ctx.lineTo(-L * 0.18, -H * 1.9);
  ctx.lineTo(L * 0.14, -H * 1.9); ctx.lineTo(L * 0.26, -H); ctx.lineTo(L / 2, -H * 0.8); ctx.lineTo(L / 2, 0); ctx.closePath(); ctx.fill();
  ctx.fillStyle = c2; ctx.globalAlpha = 0.9;
  ctx.fillRect(-L * 0.15, -H * 1.75, L * 0.13, H * 0.7); ctx.fillRect(L * 0.01, -H * 1.75, L * 0.12, H * 0.7);
  ctx.fillRect(-L / 2, -H * 0.55, L, H * 0.12);
  ctx.globalAlpha = 1;
  [-L * 0.3, L * 0.3].forEach((wx) => {
    ctx.fillStyle = "#000"; ctx.beginPath(); ctx.arc(wx, 0, H * 0.62, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = c2; ctx.lineWidth = 1.5; ctx.beginPath(); ctx.arc(wx, 0, H * 0.4, 0, Math.PI * 2); ctx.stroke();
    for (let k = 0; k < 6; k++) { const a = k + t * 8; ctx.beginPath(); ctx.moveTo(wx, 0); ctx.lineTo(wx + Math.cos(a) * H * 0.4, Math.sin(a) * H * 0.4); ctx.stroke(); }
  });
  ctx.restore();
};

export const LOWRIDER = (ctx, { w, h, t, pulse, beat, c1, c2 }) => {
  const road = h * 0.86;
  ctx.globalAlpha = 0.45;
  for (let k = 0; k < 4; k++) palm(ctx, ((k * w) / 3 - (t * 60) % (w / 3) + w) % (w + 40) - 20, road - 4, h * 0.55, c1);
  ctx.globalAlpha = 1;
  ctx.fillStyle = c1; ctx.fillRect(0, road, w, 2);
  for (let x = -(t * 160) % 30; x < w; x += 30) ctx.fillRect(x, road + 6, 14, 2);
  const hop = pulse * h * 0.22;
  const front = beat % 4 === 3; // every 4th beat: three-wheel style front hop
  const L = Math.min(w * 0.42, h * 2.2);
  lowrider(ctx, w * 0.5, road - h * 0.08 - hop * (front ? 0.5 : 1), L, front ? -pulse * 0.18 : 0, c1, c2, t);
  ctx.fillStyle = c2; ctx.globalAlpha = 0.6 * pulse;
  for (let k = 0; k < 5; k++) ctx.fillRect(w * 0.5 - L * 0.5 - 6 - k * 7, road - 6 - k * 2, 4, 2);
  ctx.globalAlpha = 1;
};

export const SUNSET = (ctx, { w, h, t, lv, bass, c1, c2 }) => {
  const hz = h * 0.62, r = h * (0.42 + bass * 0.08);
  ctx.fillStyle = c2;
  ctx.beginPath(); ctx.arc(w / 2, hz, r, Math.PI, 0); ctx.fill();
  ctx.fillStyle = "#000";
  for (let k = 0; k < 6; k++) { const y = hz - r * (0.12 + k * 0.14); ctx.fillRect(w / 2 - r, y, r * 2, 1.5 + k * 0.6 * (1 - lv[k * 3])); }
  ctx.strokeStyle = c1; ctx.lineWidth = 1;
  ctx.beginPath(); ctx.moveTo(0, hz); ctx.lineTo(w, hz); ctx.stroke();
  for (let k = 1; k < 8; k++) { const y = hz + Math.pow(((k + (t * 1.5) % 1) / 8), 2) * (h - hz); ctx.globalAlpha = 0.7; ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(w, y); ctx.stroke(); }
  for (let k = -8; k <= 8; k++) { ctx.beginPath(); ctx.moveTo(w / 2 + k * 10, hz); ctx.lineTo(w / 2 + k * 70, h); ctx.stroke(); }
  ctx.globalAlpha = 1;
  palm(ctx, w * 0.12, hz, h * 0.5, c1); palm(ctx, w * 0.86, hz, h * 0.42, c1);
};

export const CITY = (ctx, { w, h, t, lv, pulse, c1, c2, s }) => {
  if (!s.city || s.cityW !== w) { s.cityW = w; s.city = Array.from({ length: 24 }, (_, i) => ({ base: 0.25 + ((Math.sin(i * 12.9) + 1) / 2) * 0.35, wd: 0.7 + ((i * 7) % 3) * 0.15 })); }
  ctx.fillStyle = c2; ctx.globalAlpha = 0.9; ctx.beginPath(); ctx.arc(w * 0.85, h * 0.22, h * 0.12, 0, Math.PI * 2); ctx.fill(); ctx.globalAlpha = 1;
  const bw = w / 24;
  s.city.forEach((b, i) => {
    const bh = h * Math.min(0.95, b.base + lv[i] * 0.55);
    const x = i * bw, wid = bw * b.wd;
    ctx.fillStyle = c1; ctx.globalAlpha = 0.85; ctx.fillRect(x, h - bh, wid, bh);
    ctx.globalAlpha = 1; ctx.fillStyle = "#000";
    for (let y = h - bh + 4; y < h - 4; y += 6) for (let wx = x + 2; wx < x + wid - 3; wx += 5) {
      if (Math.sin(wx * 3.1 + y * 1.7 + Math.floor(t * 2 + i)) > 0.3 - pulse * 0.5) ctx.fillRect(wx, y, 2, 2);
    }
    if (i % 6 === 2) { ctx.fillStyle = c2; ctx.globalAlpha = pulse; ctx.fillRect(x + wid / 2 - 1, h - bh - 6, 2, 6); ctx.globalAlpha = 1; }
  });
};

export const WARP = (ctx, { w, h, bass, pulse, c1, c2, s }) => {
  if (!s.stars) s.stars = Array.from({ length: 140 }, () => ({ x: Math.random() * 2 - 1, y: Math.random() * 2 - 1, z: Math.random() }));
  const speed = 0.006 + bass * 0.03 + pulse * 0.02;
  s.stars.forEach((st) => {
    const pz = st.z;
    st.z -= speed;
    if (st.z <= 0.02) { st.x = Math.random() * 2 - 1; st.y = Math.random() * 2 - 1; st.z = 1; return; }
    const sx = w / 2 + (st.x / st.z) * w * 0.5, sy = h / 2 + (st.y / st.z) * h * 0.5;
    const px = w / 2 + (st.x / pz) * w * 0.5, py = h / 2 + (st.y / pz) * h * 0.5;
    ctx.strokeStyle = st.z < 0.3 ? c2 : c1; ctx.globalAlpha = Math.min(1, 1.2 - st.z); ctx.lineWidth = st.z < 0.3 ? 2 : 1;
    ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(sx, sy); ctx.stroke();
  });
  ctx.globalAlpha = 1;
};

export const FIRE = (ctx, { w, h, t, lv, c1, c2 }) => {
  const cols = 48, cw = w / cols;
  for (let i = 0; i < cols; i++) {
    const l = lv[Math.floor((Math.abs(i - cols / 2) / (cols / 2)) * 23)];
    const flick = 0.75 + 0.25 * Math.sin(t * 13 + i * 1.7) * Math.sin(t * 7 + i);
    const fh = h * (0.15 + l * 0.85) * flick;
    const g = ctx.createLinearGradient(0, h, 0, h - fh);
    g.addColorStop(0, c2); g.addColorStop(0.6, c1); g.addColorStop(1, "transparent");
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(i * cw, h); ctx.quadraticCurveTo(i * cw + cw / 2 + Math.sin(t * 9 + i) * cw, h - fh * 1.1, i * cw + cw, h); ctx.fill();
  }
  ctx.fillStyle = c2;
  for (let k = 0; k < 10; k++) { const x = ((k * 97 + t * 30) % w), y = h - ((t * 60 + k * 37) % h); ctx.globalAlpha = y / h; ctx.fillRect(x, y, 2, 2); }
  ctx.globalAlpha = 1;
};

export const SCENES = { DOLPHIN, LOWRIDER, SUNSET, CITY, WARP, FIRE };
